export default __webpack_public_path__ + "static/media/light_green.1717c5a0.png";